import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated } from '../../utils/tokenManager';


interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const auth = isAuthenticated();

  if (!auth) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

